import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { FinancialReviewViewHeaderModel } from './finnancial-review-view-header/financial-review-view-header.model';

@Injectable()
export class FinancialItemDbSourceService {
  private dbUpdateRequestedSource = new Subject<FinancialReviewViewHeaderModel>();

  dbSourceUpdateRequested$ = this.dbUpdateRequestedSource.asObservable();

  requestDbSourceUpdate(model: FinancialReviewViewHeaderModel) {
    this.dbUpdateRequestedSource.next(model);
  }
}
